import React, { useContext, useEffect, useState } from "react";

import estilo from "./styles/Perfil.module.css";
import { usePageVisibility } from "react-page-visibility";
import supabase from "../supabase/supabaseClient";
import { DataContext } from "../context/DataContext";

function Perfil() {
  const { usuario, url } = useContext(DataContext);

  const [datos, setDatos] = useState([]);

  //controlador
  const isVisible = usePageVisibility();

  React.useEffect(() => {
    if (isVisible) {
      actualizarEstado(true);
    } else {
      actualizarEstado(false);
    }
  }, [isVisible]);

  async function actualizarEstado(conectado) {
    await supabase
      .from("usuarios_chat")
      .update({ estado: conectado })
      .eq("user_id", usuario.id);
  }

  useEffect(() => {
    const fetchDatos = async () => {
      const { data, error } = await supabase
        .from("usuarios_chat")
        .select()
        .eq("user_id", usuario.id);

      if (data) {
        setDatos(data);
      }
    };

    fetchDatos();
  }, []);

  return (
    <div className={estilo.perfil}>
      {datos &&
        datos.map((e) => (
          <div key={e.id} className={estilo.datos}>
            <div className={estilo.foto}>
              <img
                src={url + usuario.id}
                alt={usuario.user_metadata.first_name}
                width="50px"
                height="50px"
              />
            </div>

            <h4>Información</h4>
            <div className={estilo.detalles}>
              <div className={estilo.detalles_texto}>
                <p>Nombre</p>
                <p>{e.nombre_usuario}</p>
              </div>
              <div className={estilo.detalles_texto}>
                <p>Correo</p>
                <p>{e.correo}</p>
              </div>
              <div className={estilo.detalles_texto}>
                <p>Edad</p>
                <p>{e.edad}</p>
              </div>
              <div className={estilo.detalles_texto}>
                <p>Sexo</p>
                <p>{e.sexo}</p>
              </div>
            </div>
          </div>
        ))}
    </div>
  );
}

export default Perfil;
